/*
 * @Description: 试用期绩效考核审批详情
 * @Author: 杨志航
 * @Date: 2026-01-22 15:11:51
 */

import React, { useState, useEffect } from 'react'
import {
  Descriptions,
  Spin,
  Icon,
  message,
  Steps,
  Button,
  Modal,
  Input,
  Form,
  Upload,
  Tag,
  Table,
  DatePicker,
} from 'antd'
import api from '@/api'
import { parseSearch, judgeCryptoParamsUrl, cryptoParamsIntoUrl, allTrim, filterParams } from '@/utils'
import { uploadDragger } from '@/utils/uploadDragger'
import { Link } from 'react-router-dom'

const DItem = Descriptions.Item
const FormItem = Form.Item
const { Step } = Steps
const { Column } = Table
const { Dragger } = Upload
const dateFormat = 'YYYY-MM-DD'
let draggerEvaluation = {}
let draggerObj = {}

const Detail = (props) => {
  const { location, history } = props
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const search = parseSearch(location.search)
  const [loading, setLoading] = useState(true)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [detail, setDetail] = useState({})
  const [statusList, setStatusList] = useState([])
  const [logConList, setLogConList] = useState([])
  const [buttonAuthList, setButtonAuthList] = useState([])
  const [auditModalVisible, setAuditModalVisible] = useState(false)
  const [auditStatus, setAuditStatus] = useState(0) // 0-通过，1-驳回
  const [remark, setRemark] = useState('')

  useEffect(() => {
    draggerEvaluation = uploadDragger({
      accept: '.xlsx, .pdf',
      limitNum: 20,
      limitSize: 20,
    })
    draggerObj = uploadDragger({
      accept: '.jpg, .jpeg, .pdf',
      limitNum: 20,
      limitSize: 20,
    })
    if (judgeCryptoParamsUrl(search)) {
      getDetail()
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.goBack()
      }, 1000)
    }
  }, [])

  //获取详情
  const getDetail = () => {
    setLoading(true)
    api.getAchProbationReviewInfo({
      id: search.id
    }).then(data => {
      if (search.msgId) {
        api.setMessageReaded({ ids: [search.msgId] })
      }
      setDetail(data)
      setStatusList(data.procedureStatusList) // 审批进度
      setLogConList(data.logList) // 审批记录
      setButtonAuthList(data.auditAuth) // 审批权限
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 2 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    }
  }

  const handleAudit = () => {
    setConfirmLoading(true)
    if (auditStatus === 1 && buttonAuthList.reject_msg_require && remark === '') {
      message.error('请输入驳回审批意见')
      setConfirmLoading(false)
      return
    }
    const { id, needUpEvaluationFile, needAttachments } = detail
    let params = {
      id,
      type: auditStatus,
    }
    if (remark) {
      params.remark = remark
    }
    if (auditStatus === 0 && needUpEvaluationFile === 1) {
      const vals = filterParams(getFieldsValue())
      params.evaluationFileInfo = vals.evaluationFileInfo.map(item => {
        const { name, url } = item
        return {
          name,
          url,
        }
      })
    }
    if (auditStatus === 0 && needAttachments === 1) {
      const { 
        determineJoinDate, 
        contacts, 
        evaluation, 
        jobPostFiles, 
        salesAssessmentRoles, 
        other 
      } = filterParams(getFieldsValue())
      params.determineJoinDate = determineJoinDate.format(dateFormat)
      params.attachments = {
        contacts: contacts.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        }),
        evaluation: evaluation.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        }),
        jobPostFiles: jobPostFiles.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        }),
      }
      if (salesAssessmentRoles) {
        params.attachments.salesAssessmentRoles = salesAssessmentRoles.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        })
      }
      if (other) {
        params.attachments.other = other.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        })
      }
    }
    api.submitAchProbationReviewAudit(params).then(() => {
      message.success('审批完成')
      getDetail()
      setConfirmLoading(false)
      setAuditModalVisible(false)
    }).catch(() => setConfirmLoading(false))
  }

  const showAuditModal = status => {
    const { needUpEvaluationFile, needAttachments } = detail
    let flag = false
    if (status === 0 && (needUpEvaluationFile === 1 || needAttachments === 1)) {
      setFieldsValue(allTrim(getFieldsValue()))
      validateFields(err => {
        if (err) {
          flag = true
        }
      })
    }
    if (flag) {
      message.error('请填写必填项')
      return
    }
    setAuditStatus(status)
    setAuditModalVisible(true)
  }

  const handleReturnUp = () => {
    api.submitAchProbationReviewAudit({
      id: detail.id,
      type: 2,
    }).then(() => {
      getDetail()
    })
  }

  return (
    <Spin spinning={loading}>
      <div className="pro-detail">
        <Button 
          type="primary"
          onClick={() => history.goBack()}  
          style={{ position: 'absolute', right: '20px', top: '-20px' }}
        >返回上一页</Button>
        <Descriptions title="审批详情" layout="horizontal " className="pro-detail-title">
          <DItem label="当前状态"><Tag color="#108ee9">{detail.auditStatusName}</Tag></DItem>
        </Descriptions>
        <Descriptions title="当前审批进度" className="pro-detail-smailtitle"></Descriptions>
        <div className="promotionProcess" >
          <Steps>
            {
              statusList.map((item, index) => {
                let status = 'wait'
                if (item.time && item.time.length > 1) {
                  status = 'process'
                }
                return <Step status={status}
                  key={index}
                  value={item.time}
                  title={item.nodeName}
                  description={
                    <>
                      {item.persons && <div title={`${item.persons.map((item) => item)}`}>{`${item.persons.map((item) => item)}`}</div>}
                      <div title={item.statusName}>{item.statusName}</div>
                      <div title={item.time}>{item.time}</div>
                    </>
                  }
                />
              })
            }
          </Steps>
        </div>
        <div className="line"></div>
        <Descriptions 
          title="试用期员工绩效考核" 
          layout="vertical"
          className="pro-detail-smailtitle pro-apply"
        >
          {detail.rId && (
            <DItem label="招聘业务编号">
              <Link to={cryptoParamsIntoUrl('/hr/recruit/detail', { id: detail.rId })}>{detail.bizno}</Link>
            </DItem>
          )}
          <DItem label="员工姓名">{detail.name}</DItem>
          <DItem label="手机号码">{detail.mobile}</DItem>
          <DItem label="入职主体">{detail.companyName}</DItem>
          <DItem label="入职事业群">{detail.groupName}</DItem>
          <DItem label="入职部门">{detail.departmentName}</DItem>
          <DItem label="入职项目">{detail.projectsName?.join('，')}</DItem>
          <DItem label="预计入职日期"> {detail.joiningDate}</DItem>
          <DItem label="实际入职日期"> {detail.determineJoinDate || '--'}</DItem>
          <DItem label="岗位名称"> {detail.jobPostName}</DItem>
          <DItem label="岗位类别">{detail.jobTypeName}</DItem>
          <DItem label="岗位说明书">
            <a href={detail.jobPostFileInfo?.url} target="_blank">{detail.jobPostFileName}</a>
          </DItem>
          <DItem label="试用期级别">{detail.probationaryLevel}</DItem>
          <DItem label="转正级别">{detail.regularLevel}</DItem>
          <DItem label="是否管理">{detail.isManagerName}</DItem>
          <DItem label="审核部门">{detail.auditDepartmentName}</DItem>
          <DItem label="考核方式">{detail.assessmentMethodName}</DItem>
          {detail.assessmentMethod === 2 && (
            <DItem label="等级销售模板">
              <a href={detail.tInfo?.url} target="_blank">{detail.tName}</a>
            </DItem>
          )}
          <DItem label="是否实习生">{detail.isInternName}</DItem>
        </Descriptions>
        {detail.evaluationAddByName && (
          <>
            <div className="line"></div>
            <Descriptions 
              title="试用期考核表" 
              className="pro-detail-smailtitle pro-apply attachments"
              column={1}
            >
              <DItem label="附件">
                <>
                  {
                    detail.evaluationFileInfo?.map((item, index) => (
                      <div key={index}>
                        <a href={detail.auditStatus === 4 ? item.url : `${item.url}#toolbar=0`} target="_blank">{item.name}</a>
                      </div>
                    ))
                  }
                </>
              </DItem>
              <DItem label="上传人">{detail.evaluationAddByName}</DItem>
            </Descriptions>
          </>
        )}
        {detail.attachmentsAddByName && (
          <>
            <div className="line"></div>
            <Descriptions 
              title="签署资料" 
              className="pro-detail-smailtitle pro-apply attachments"
              column={1}
            >
              <DItem label="劳动合同">
                <>
                  {
                    detail.attachments?.contacts?.map((item, index) => (
                      <div key={index}>
                        <a href={detail.auditStatus === 4 ? item.url : `${item.url}#toolbar=0`} target="_blank">{item.name}</a>
                      </div>
                    ))
                  }
                </>
              </DItem>
              <DItem label="试用期绩效考核表">
                <>
                  {
                    detail.attachments?.evaluation?.map((item, index) => (
                      <div key={index}>
                        <a href={detail.auditStatus === 4 ? item.url : `${item.url}#toolbar=0`} target="_blank">{item.name}</a>
                      </div>
                    ))
                  }
                </>
              </DItem>
              <DItem label="岗位说明书">
                <>
                  {
                    detail.attachments?.jobPostFiles?.map((item, index) => (
                      <div key={index}>
                        <a href={detail.auditStatus === 4 ? item.url : `${item.url}#toolbar=0`} target="_blank">{item.name}</a>
                      </div>
                    ))
                  }
                </>
              </DItem>
              {detail.attachments?.salesAssessmentRoles && (
                <DItem label="销售考核规则">
                  <>
                    {
                      detail.attachments.salesAssessmentRoles.map((item, index) => (
                        <div key={index}>
                          <a href={detail.auditStatus === 4 ? item.url : `${item.url}#toolbar=0`} target="_blank">{item.name}</a>
                        </div>
                      ))
                    }
                  </>
                </DItem>
              )}
              {detail.attachments?.other && (
                <DItem label="其他资料">
                  <>
                    {
                      detail.attachments.other.map((item, index) => (
                        <div key={index}>
                          <a href={detail.auditStatus === 4 ? item.url : `${item.url}#toolbar=0`} target="_blank">{item.name}</a>
                        </div>
                      ))
                    }
                  </>
                </DItem>
              )}
              <DItem label="上传人">{detail.attachmentsAddByName}</DItem>
            </Descriptions>
          </>
        )}
        {detail.needUpEvaluationFile === 1 && (
          <>
            <div className="line-box"></div>
            <Descriptions
              title="上传试用期考核表"
              className="pro-detail-smailtitle"
            >
            </Descriptions>
            <Form {...formItemLayout}>
              <FormItem label="试用期考核表">
                {getFieldDecorator('evaluationFileInfo', {
                  valuePropName: 'fileList',
                  getValueFromEvent: draggerEvaluation.normFile,
                  rules: [{ required: true, message: '请上传试用期考核表' }]
                })(
                  <Dragger {...draggerEvaluation}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      支持扩展名：.xlsx、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
                    </p>
                  </Dragger>
                )}
              </FormItem>
            </Form>
          </>
        )}
        {detail.needAttachments === 1 && (
          <>
            <div className="line-box"></div>
            <Descriptions
              title="上传签署资料"
              className="pro-detail-smailtitle"
            >
            </Descriptions>
            <Form {...formItemLayout}>
              <FormItem label="实际入职日期">
                {getFieldDecorator('determineJoinDate', {
                  rules: [{ required: true, message: '请选择实际入职日期' }]
                })(
                  <DatePicker placeholder="请选择实际入职日期" style={{ width: '100%'}}/>
                )}
              </FormItem>
              <FormItem label="劳动合同">
                {getFieldDecorator('contacts', {
                  valuePropName: 'fileList',
                  getValueFromEvent: draggerObj.normFile,
                  rules: [{ required: true, message: '请上传劳动合同' }]
                })(
                  <Dragger {...draggerObj}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      支持扩展名：.jpg、.jpeg、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
                    </p>
                  </Dragger>
                )}
              </FormItem>
              <FormItem label="试用期绩效考核表">
                {getFieldDecorator('evaluation', {
                  valuePropName: 'fileList',
                  getValueFromEvent: draggerObj.normFile,
                  rules: [{ required: true, message: '请上传试用期绩效考核表' }]
                })(
                  <Dragger {...draggerObj}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      支持扩展名：.jpg、.jpeg、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
                    </p>
                  </Dragger>
                )}
              </FormItem>
              <FormItem label="岗位说明书">
                {getFieldDecorator('jobPostFiles', {
                  valuePropName: 'fileList',
                  getValueFromEvent: draggerObj.normFile,
                  rules: [{ required: true, message: '请上传岗位说明书' }]
                })(
                  <Dragger {...draggerObj}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      支持扩展名：.jpg、.jpeg、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
                    </p>
                  </Dragger>
                )}
              </FormItem>
              <FormItem label="销售考核规则">
                {getFieldDecorator('salesAssessmentRoles', {
                  valuePropName: 'fileList',
                  getValueFromEvent: draggerObj.normFile,
                })(
                  <Dragger {...draggerObj}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      支持扩展名：.jpg、.jpeg、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
                    </p>
                  </Dragger>
                )}
              </FormItem>
              <FormItem label="其他资料">
                {getFieldDecorator('other', {
                  valuePropName: 'fileList',
                  getValueFromEvent: draggerObj.normFile,
                })(
                  <Dragger {...draggerObj}>
                    <p className="ant-upload-drag-icon">
                      <Icon type="inbox" />
                    </p>
                    <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p className="ant-upload-hint">
                      支持扩展名：.jpg、.jpeg、.pdf<br/>单个文件大小不超过20M，不超过20个附件。
                    </p>
                  </Dragger>
                )}
              </FormItem>
            </Form>
          </>
        )}
        <div className="line-box"></div>
        <Descriptions
          title="审批记录"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table
          dataSource={logConList}
          rowKey="id"
          pagination={false}
        >
          <Column title="姓名" dataIndex="userInfo.staffName" />
          <Column title="时间" dataIndex="addTime" />
          <Column title="状态" dataIndex="status" />
          <Column title="审批意见" dataIndex="chargeMsg" />
        </Table>
        {buttonAuthList.hasChargerPower && (
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '40px' }}>
            {buttonAuthList.return_up && <Button className="orange-btn" onClick={handleReturnUp} style={{ marginRight: '15px' }}>转上级</Button>}
            <Button onClick={() => showAuditModal(1)}>驳回</Button>
            <Button type="primary" onClick={() => showAuditModal(0)} style={{ marginLeft: '15px' }}>通过</Button>
          </div>
        )}
        <Modal
          title={auditStatus === 0 ? (
            <>确认通过 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
          ) : (
            <>确认驳回 <Icon type="close-circle" theme="twoTone" twoToneColor="#DC143C" /></>
          )}
          visible={auditModalVisible}
          onOk={handleAudit}
          onCancel={() => setAuditModalVisible(false)}
          confirmLoading={confirmLoading}
        >
          <div>
            <span>审批意见:</span>
            <Input.TextArea 
              placeholder="请输入审批意见" 
              value={remark} 
              onChange={evt => setRemark(evt.target.value.trim())} 
              maxLength={100} 
            />
          </div>
        </Modal>
      </div>
    </Spin>
  )
}

export default Form.create()(Detail)
